import { useEffect, useState } from "react";
import ChatArrowSVG from "../../../assets/icons/svg/ChatArrowSVG";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import PremiumIconSVG from "../../../assets/icons/svg/PremiumIconSVG";
import { getUserObject } from "../../../../../utils/getUserObject";

export const SendMessageFormDisable = ({ onClose }) => {
    const [messagePayload, setMessagePayload] = useState('');
    const [premium, setPremium] = useState(false);

    useEffect(() => {
        const user = getUserObject();
        if (user?.role === "seller_plus") {
            setPremium(true)
        }
    }, []);

    return (
        <div style={styles.sidebar}>
            <button onClick={onClose} style={styles.closeButton}>×</button>

            <div style={styles.contentWrapper}>
                <div style={styles.chatTitle}>
                    <strong>Poruke</strong>
                </div>

                {!premium && (
                    <div style={styles.wrapper}>
                        <div style={styles.textBox}>
                            <div style={styles.title}>
                                <strong>Samo premium korisnici imaju ovu uslugu.</strong>
                            </div>
                            <div style={styles.description}>
                                Nadogradnja na premium traje samo 2 minuta, a odmah nakon aktivacije moći ćete da koristite chat bez ikakvih ograničenja.
                            </div>
                        </div>

                        <button style={styles.premiumButton}>
                            Aktiviraj Premium Paket <PremiumIconSVG />
                        </button>
                    </div>
                )}
            </div>

            <div style={styles.inputWrapper}>
                <div style={styles.mainContianer}>
                    <input
                        value={messagePayload}
                        onChange={(e) => setMessagePayload(e.target.value)}
                        placeholder="Upiši poruku za prodavca"
                        style={styles.input}
                        disabled={true}
                    />
                    <div
                        style={{
                            ...styles.sendMessageButtonContianer,
                            cursor: "not-allowed",
                            backgroundColor: "#ccc",
                        }}
                    >
                        <ChatArrowSVG />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendMessageFormDisable;



const styles = {
    mainContianer: {
        display: 'flex',
        alignItems: 'center',
        width: "340px",
        border: "1px solid #0000003b",
        borderRadius: 4,
        padding: "10px"
    },
    input: {
        flex: 1,
        backgroundColor: 'transparent',
        border: "1px solid transparent",
        borderRadius: 6,
        paddingInline: 8,
        fontFamily: FontEnum.TITILIUM_WEB,
    },
    sendMessageButtonContianer: {
        display: 'flex',
        height: "40px",
        width: "40px",
        borderRadius: 8,
        backgroundColor: "#ccc",
        alignItems: 'center',
        justifyContent: 'center'
    },
    sidebar: {
        position: "fixed",
        top: 0,
        right: 0,
        height: "100vh",
        width: "400px",
        backgroundColor: "#fff",
        boxShadow: "-4px 0 12px rgba(0, 0, 0, 0.2)",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 16,
    },
    closeButton: {
        position: "absolute",
        top: 8,
        right: 8,
        background: "transparent",
        border: "none",
        fontSize: 20,
        cursor: "pointer",
        color: "rgba(0, 0, 0, 0.23)",
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        marginTop: 40,
        flexGrow: 1,
        overflow: "hidden",
    },
    chatTitle: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "24px",
        fontWeight: 600,
    },
    wrapper: {
        padding: 20,
        border: "2px solid #693EFF",
        borderRadius: 12,
        backgroundColor: "#F5F5F4",
        display: "flex",
        flexDirection: "column",
        gap: 16,
    },
    textBox: {
        display: "flex",
        flexDirection: "column",
        gap: 30,
        width: "334px",
        height: "150px",
    },
    title: {
        fontSize: 16,
        fontWeight: 700,
        color: "rgba(0, 0, 0, 0.87)",
    },
    description: {
        fontSize: 16,
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.87)",
        lineHeight: "24px",
    },
    premiumButton: {
        width: 258,
        height: 48,
        border: "2px solid #000",
        backgroundColor: "#fff",
        borderRadius: 8,
        fontSize: 16,
        fontWeight: 700,
        color: "#000",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
    },

    inputWrapper: {
        marginTop: 12,
    },

}
